import "./styles/main.scss";

document.addEventListener("alpine:init", () => {
	Alpine.data("wp_block_d3_security_vertical_faq_tabs", () => ({
		$tabs: null,
		$content: null,
		$faq_items: null,

		currentTab: 0,

		setActive(currentTab) {
			this.currentTab = currentTab;

			// Get Faq node
			//this.$faq_item = this.

			this.$faq_items.forEach(($faq, index) => {
				$faq.removeAttribute('open', '');
			});

			this.$tabs.forEach(($tab, index) => {
				$tab.classList.toggle("is-active", index + 1 === currentTab);
				//$tab.setAttribute('open', '');
			});

			this.$content.forEach(($content, index) => {
				$content.classList.toggle("is-active", index + 1 === currentTab);
			});

		},

		init() {
			this.$tabs = this.$el.querySelectorAll(".inner-blocks .wp-block-d3-security-vertical-faq-tabs-item");
			this.$faq_items = this.$el.querySelectorAll(".inner-blocks .wp-block-d3-security-vertical-faq-tabs-item .wp-block-d3-security-faq-list-item");
			this.$content = this.$el.querySelectorAll(".tab-images > div");

			this.$tabs.forEach(($tab, index) => {
				$tab.addEventListener("click", () => {
					this.setActive(index + 1);
				});
			});

			this.setActive(1);
		},
	}));
});
